import { useMutation } from '@tanstack/react-query';
import { updateWorkflowConfig, WorkflowConfigUpdate } from 'services/api/WorkflowServiceAPI';
import { queryClient } from 'services/providers/QueryProvider';
import { queryKeys } from '../queryKeys';

export const useUpdateWorkflowConfig = () => {
    const { mutateAsync, ...rest } = useMutation({
        mutationFn: ({ id, config }: { id: string; config: WorkflowConfigUpdate }) => updateWorkflowConfig(id, config),
        // The provider default is retry: 1, but this endpoint validates and
        // answers 400 on bad input; re-sending it just doubles the failure.
        retry: 0,
        onSuccess: (_data, { id }) => {
            queryClient.invalidateQueries({ queryKey: queryKeys.workflowConfig(id) });
            queryClient.invalidateQueries({
                predicate: ({ queryKey }) => queryKey.includes('agenticWorkflowDetails'),
            });
        },
    });

    return {
        updateWorkflowConfig: mutateAsync,
        ...rest,
    };
};
